module.exports = __webpack_public_path__ + "img/pamphlet_thumb02.4acc1e58.png";